@file:OptIn(ExperimentalTime::class)

package com.macrofocus.eflux

import korlibs.time.DateTime
import korlibs.time.DateTimeTz
import korlibs.time.TimezoneOffset
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.offsetAt
import kotlinx.datetime.toInstant
import kotlin.time.ExperimentalTime
import kotlin.time.Instant

fun DateTime.toRawString() : String {
    return yearInt.toString().padStart(4, '0') +
            (month1).toString().padStart(2, '0') +
            dayOfMonth.toString().padStart(2, '0') +
            "_" +
            hours.toString().padStart(2, '0') +
            minutes.toString().padStart(2, '0')
}

fun DateTime.toRawStringSeconds() : String {
    return yearInt.toString().padStart(4, '0') +
            (month1).toString().padStart(2, '0') +
            dayOfMonth.toString().padStart(2, '0') +
            "_" +
            hours.toString().padStart(2, '0') +
            minutes.toString().padStart(2, '0') +
            ":" +
            seconds.toString().padStart(2, '0')
}

fun String.toDateTime() : DateTime {
    val year = substring(0, 4).toInt()
    val month = substring(4, 6).toInt()
    val day = substring(6, 8).toInt()
    val hour = substring(9, 11).toInt()
    val min = substring(11, 13).toInt()
    return DateTime(year, month, day, hour, min, 0, 0)
}

/**
 * Converts this string containing date and time in the format yyyyMMdd_HHmm in the specified time zone
 * (default to Europe/Zurich) to an Instant (UTC time zone)
 */
fun String.toInstant(timeZone: TimeZone = TimeZone.of("Europe/Zurich")) : Instant {
    val year = substring(0, 4).toInt()
    val month = substring(4, 6).toInt()
    val day = substring(6, 8).toInt()
    val hour = substring(9, 11).toInt()
    val min = substring(11, 13).toInt()

    val localDateTime = LocalDateTime(year, month, day, hour, min, 0)
    return localDateTime.toInstant(timeZone)
}

/**
 * Converts this instant to the ISO 8601 string representation, for example, 2023-01-02T23:40:57.120Z
 */
fun Instant.toISO8601() : String {
    return toString()
}


fun String.toKDateTimeTz() : DateTimeTz {
    val zurichTimeZone = TimeZone.of("Europe/Zurich")

    val year = substring(0, 4).toInt()
    val month = substring(4, 6).toInt()
    val day = substring(6, 8).toInt()
    val hour = substring(9, 11).toInt()
    val min = substring(11, 13).toInt()
    val date = DateTime(year, month, day, hour, min, 0, 0)
    val offset = TimezoneOffset(zurichTimeZone.offsetAt(instant()).totalSeconds * 1000.0)
    val datetz = DateTimeTz.local(date, offset)
    return datetz
}

fun String.instant() : Instant {
//    val zurichTimeZone = TimeZone.of("Europe/Zurich")
    val zurichTimeZone = TimeZone.of("Europe/Zurich")

    val year = substring(0, 4).toInt()
    val month = substring(4, 6).toInt()
    val day = substring(6, 8).toInt()
    val hour = substring(9, 11).toInt()
    val min = substring(11, 13).toInt()
    val date = kotlinx.datetime.LocalDateTime(year, month, day, hour, min, 0, 0)
    val instant = date.toInstant(zurichTimeZone)
    return instant
}

fun String.toDateTimeTz(timeZone: TimeZone = TimeZone.of("Europe/Zurich")) : org.molap.datetime.DateTimeTz {
    val year = substring(0, 4).toInt()
    val month = substring(4, 6).toInt()
    val day = substring(6, 8).toInt()
    val hour = substring(9, 11).toInt()
    val min = substring(11, 13).toInt()
    val date = LocalDateTime(year, month, day, hour, min, 0, 0)
    val instant = date.toInstant(timeZone)
    return org.molap.datetime.DateTimeTz(instant, timeZone)
}

fun DateTimeTz.toTzString() : String {
    return yearInt.toString().padStart(4, '0') +
            "-" +
            (month1).toString().padStart(2, '0') +
            "-" +
            dayOfMonth.toString().padStart(2, '0') +
            "T" +
            hours.toString().padStart(2, '0') +
            ":" +
            minutes.toString().padStart(2, '0') +
            "Z"
}


